module.exports = __webpack_public_path__ + "img/427-fe8f2e.png";